<template>
  <div class="main">
    <img class="headBanner" src="../../assets/img/pay/djsBanner.png" />
    <p class="stateP">支付结果确认中<br />请耐心等待…</p>
    <p class="textP">
      系统正在获取您的支付结果，大约需要<span style="color:#EA332B;">3～15</span
      >秒
    </p>
    <div v-if="times === 0 && fxshow" class="todetailBtn" @click="toDetail">
      查看订单详情
    </div>
    <div v-if="fxshow && times > 0" class="todetailBtn2">
      查看订单详情 ({{ times }})
    </div>
  </div>
</template>

<script>
  import { FindInsurancePayOrderByOrderSn } from '../../api/user'
  import { getDeviceInfo } from '@/util/tools'
  import { SetLeChengShare } from '@/util/set-wx-share'
  export default {
    name: 'BuySuccess',
    components: {},
    filters: {},
    mixins: [],
    props: {},
    data() {
      return {
        fromSourceCode: '',
        insuranceId: '',
        payType: '',
        insuranceProductCode: '',
        loadingShow: true,
        fxshow: false,
        show: false,
        platInfo: getDeviceInfo(),
        times: 15
      }
    },
    computed: {},
    watch: {
      $route: {
        handler: function(newVal, oldVal) {
          if (newVal.fullPath !== oldVal.fllPath) {
            this.initPage()
          }
        }
      }
    },
    created() {},
    mounted() {
      this.loadingShow = true
      this.initPage()
      if (this.platInfo.env === 'wechat') {
        this.fxshow = true
      } else {
        this.fxshow = false
      }
    },
    destroyed() {
      sessionStorage.removeItem('buySuccess')
    },
    methods: {
      // 查看详情
      toDetail() {
        // console.log('this.insuranceId', this.insuranceId)
        this.$router.push({
          path: '/policy-detail/' + this.insuranceId
        })
      },
      onload_execwx() {
        //初始化小票
        console.log('支付成功页打印')
        var initData = {
          action: 'onIframeReady',
          displayStyle: 'SHOW_CUSTOM_PAGE',
          height: 960
        }
        var initPostData = JSON.stringify(initData)
        if (parent && typeof parent.postMessage === 'function')
          parent.postMessage(initPostData, 'https://payapp.weixin.qq.com')
      },
      async initPage() {
        this.onload_execwx()
        sessionStorage.getItem('buySuccess')

        localStorage.setItem('orderSn', this.$route.params.orderSn)
        this.orderSn = this.$route.params.orderSn

        if (this.orderSn === 'invite') {
          return
        }
        let orderInfo = await FindInsurancePayOrderByOrderSn({
          orderSn: this.orderSn
        })
        this.insuranceId = orderInfo.userInsureId
        this.payType = orderInfo.insureEn.payType
        this.insuranceProductCode = orderInfo.insureEn.insuranceProductCode
        this.fromSourceCode = orderInfo.insureEn.realSourceCode
        console.log('this.orderInfo', orderInfo)

        // alert('去补录页 已支付')
        // this.$router.push({
        //   path: '/buy-product-success',
        //   query: {
        //     insuranceId: this.insuranceId,
        //     payType: this.payType,
        //     fromSourceCode: this.fromSourceCode,
        //     baosicode: this.insuranceProductCode
        //   }
        // })

        if (orderInfo.status === 'yetPay') {
          // waitPay 待支付 yetPay 已支付
          // 关掉loading
          if (
            orderInfo.insureEn.isAdvancePayment &&
            Number(orderInfo.insureEn.isAdvancePayment) === 1
          ) {
            // 不为空且为1 去补录页
            this.$router.push({
              path: '/buy-product-success',
              query: {
                insuranceId: this.insuranceId,
                payType: this.payType,
                fromSourceCode: this.fromSourceCode,
                baosicode: this.insuranceProductCode
              }
            })
          } else {
            this.$router.push({
              path: '/buy-product-success',
              query: {
                insuranceId: this.insuranceId,
                payType: this.payType,
                fromSourceCode: this.fromSourceCode,
                baosicode: this.insuranceProductCode
              }
            })
          }
          this.loadingShow = false
        } else {
          // 每秒请求一次，5次后orderInfo.status !== 'yetPay' 跳转新页面；5秒内出现orderInfo.status === 'yetPay'情况则结束轮询留在当前页
          this.times = 15
          let timer = setInterval(async () => {
            this.times--
            if (this.times > 0) {
              console.log('倒计时')
              //  发送接口
              let orderInfo2 = await FindInsurancePayOrderByOrderSn({
                orderSn: this.orderSn
              })
              this.insuranceId = orderInfo2.userInsureId
              this.payType = orderInfo2.insureEn.payType
              if (orderInfo2.status === 'yetPay') {
                clearInterval(timer)
                if (
                  orderInfo2.insureEn.isAdvancePayment &&
                  Number(orderInfo2.insureEn.isAdvancePayment) === 1
                ) {
                  // 不为空且为1 去补录页
                  this.$router.push({
                    path: '/buy-product-success',
                    query: {
                      insuranceId: this.insuranceId,
                      payType: this.payType,
                      fromSourceCode: this.fromSourceCode,
                      baosicode: this.insuranceProductCode
                    }
                  })
                } else {
                  this.$router.push({
                    path: '/buy-product-success',
                    query: {
                      insuranceId: this.insuranceId,
                      payType: this.payType,
                      fromSourceCode: this.fromSourceCode,
                      baosicode: this.insuranceProductCode
                    }
                  })
                }
                this.loadingShow = false
              }
            } else {
              //  一分钟后没有失败信息，怎算支付成功跳转页面 this.router
              clearInterval(timer)
              // this.$router.push({
              //   path: '/customer-service'
              // })
            }
          }, 1000)
        }
        SetLeChengShare()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .payFail {
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #5675f1;
    line-height: 42px;
    text-align: center;
    margin-top: 5px;
  }
  .todetailBtn2 {
    height: 50px;
    opacity: 0.7;
    background: #888888;
    border-radius: 25px;
    text-align: center;
    font-size: 16px;
    line-height: 50px;
    color: #fff;
    width: 80%;
    margin-left: 10%;
    margin-top: 30px;
  }
  .todetailBtn {
    height: 50px;
    background: linear-gradient(135deg, #ff7828 0%, #ff282c 100%);
    border-radius: 25px;
    text-align: center;
    font-size: 16px;
    line-height: 50px;
    color: #fff;
    width: 80%;
    margin-left: 10%;
    margin-top: 30px;
  }
  .textP {
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #888888;
    line-height: 2;
    margin-top: 4px;
  }
  .headBanner {
    display: block;
    width: 100%;
  }
  .loadingPoup {
    width: 50%;
    height: 200px;
    background: #000;
    text-align: center;
    position: fixed;
    left: 25%;
    top: 30%;
    color: #fff;
  }
  .stateP {
    color: #555555;
    font-size: 16px;
    line-height: 26px;
    text-align: center;
    margin: 26px 0 0px;
  }
  .not_banner {
    width: 100%;
  }
  .centent_img {
    text-align: center;
    padding: 25px 30px;
    font-size: pxrem(28);
    line-height: pxrem(60);
    color: #000;
    img {
      width: 100%;
      margin-top: 20px;
    }
  }
</style>
